import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/after-sales/[[...slug]]/_components/AfterSalesPage.tsx");
